module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"branches":"Filialen","exportAllOrders":"Alle Bestellungen exportieren","orderAnalytics":"Bestellanalyse","other":"Andere"},"en":{"branches":"Branches","exportAllOrders":"Export all orders","orderAnalytics":"Order analytics","other":"Others"}}')
  delete Component.options._Ctor
}
